import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/mixins/chartjs';
import 'src/mixins/prismjs';
import 'src/mock';
import { enableES5 } from 'immer';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/context/SettingsContext';
import store from 'src/store';
import { restoreSettings } from 'src/utils/settings';
import App from 'src/App';
import WrongDomainNotice from 'src/components/WrongDomainNotice';
import {
  DEFAULT_APP_BASE_URL,
  buildContinueUrl,
  displayHostFromUrl,
  isAllowedOnFormsDomain,
  isFormsDomainHost,
} from 'src/utils/wrongDomain';

enableES5();

const settings = restoreSettings();
const container = document.getElementById('root');
const root = createRoot(container);

// Fallback layer behind the Next.js middleware in middleware.js. The
// middleware is the real block; this catches any request that reaches the SPA
// without passing through it. Same path allowlist as the middleware, so public
// forms served through the SPA still render.
if (
  isFormsDomainHost(window.location.hostname)
  && !isAllowedOnFormsDomain(window.location.pathname)
) {
  const configuredBaseUrl = process.env.REACT_APP_APP_BASE_URL;
  if (!configuredBaseUrl) {
    console.warn(
      `[wrong-domain] REACT_APP_APP_BASE_URL is not set, falling back to ${DEFAULT_APP_BASE_URL}`
    );
  }
  const baseUrl = configuredBaseUrl || DEFAULT_APP_BASE_URL;
  const requestedPath = `${window.location.pathname}${window.location.search}`;

  root.render(
    <WrongDomainNotice
      continueUrl={buildContinueUrl(baseUrl, requestedPath)}
      displayHost={displayHostFromUrl(baseUrl)}
    />
  );
} else {
  root.render(
    <Provider store={store}>
      <SettingsProvider settings={settings}>
        <App />
      </SettingsProvider>
    </Provider>
  );
}

serviceWorker.unregister();
